<template>
    <ItemMenuList :isLoading="isLoadingStationClocks">
        <template slot="Content">
            <b-list-group v-if="stationClocks!=null && stationClocks.count > 0">
                <MenuCard v-for="clock in stationClocks.items" :key="clock.uid" :menuItem="clock" :href="{name:'ClockDetails', params:{clockUid: clock.uid}}">
                    <template slot="Decorator">
                        <i class="fas fa-circle" :style="{ color: clock.colorCode }"></i>
                    </template>
                    <template slot="Badge">
                        <span></span>
                    </template>
                </MenuCard>
            </b-list-group>
            <div v-else class="alert alert-info">
                No Clock found
            </div>
        </template>
        <template slot="Actions">
            <ClockCreationButton :empty="true"/>
        </template>
    </ItemMenuList>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store'
    import router from '@/router'
    import ItemMenuList from'@/components/common/ItemMenuList'
    import MenuCard from'@/components/common/MenuCard'
    import Button from '@/components/common/Button'
    import ClockCreationButton from "./ClockCreationButton"

    Vue.use(BootstrapVue)

    export default {
        name: "ClockMenuList",
        router, store,
        components: { ItemMenuList, MenuCard, Button, ClockCreationButton },
        computed: {
            ...mapState(['stationClocks', 'isLoadingStationClocks'])
        },
        //data() {
        //    return {
        //        ...mapState({
        //            isLoadingData: function () { return store.state.loadingStates.isLoadingStationClocks },
        //            clockListData: function () { return store.state.stationClocks }
        //        })
        //    }
        //},
    }
</script>

<style scoped>
    .fas.fa-circle {
        /* border: 1.5px solid #d2d2d2; */
        border-radius: 100px;
    }
</style>
